import { AxiosResponse } from "axios";

import { microserviceApiRoutes } from "../../microservice-api.routes";
import { microserviceApiAxios } from "../../microservice-api.axios";
import { IIListCityRes } from "./city-service.interface";

export const listCityInsurrance = (country?: string) => {
  const url = microserviceApiRoutes.v1.shared.city.list();
  return microserviceApiAxios
    .get<Error, AxiosResponse<IIListCityRes>>(url, {
      params: country ? { country } : undefined,
    })
    .then((res) => res.data);
};
